import { proAccessTerms } from "consts/urls";

export const allInsights = "All Insights";
export const watchlists = "Watchlists";
export const alerts = "Alerts";
export const readingList = "Reading List";
export const discussion = "Discussions";
export const corporateAccess = "Corporate Access";
export const accountManagement = "Account Management";
export const messaging = "Messaging";
export const tools = "Data Tools";
export const compliance = "Compliance Suite";

const smartkarmaPro = {
  id: "smartkarma-pro",
  title: "Smartkarma Pro",
  subtitle: "For Professional Investors\n& Licensed Asset Managers",
  linkedPlan: () => require("./smartkarmaPlus"),
  linkedPlanLinkText: "",
  linkedPlanLink: "View Private Investor Plans Instead »",
  style: "denim",
  options: [
    {
      id: 1,
      title: "Annual Plan",
      priceScope: "year",
      priceScopeInMonth: 12,
      price: 10950,
      stripePlan: "investor-pro-yearly",
    },
  ],
  features: [
    {
      title: allInsights,
      enabled: true,
    },
    {
      title: watchlists,
      enabled: true,
    },
    {
      title: alerts,
      enabled: true,
    },
    {
      title: readingList,
      enabled: true,
    },
    {
      title: discussion,
      enabled: true,
    },
    {
      title: corporateAccess,
      enabled: true,
    },
    {
      title: accountManagement,
      enabled: true,
    },
    {
      title: messaging,
      enabled: true,
    },
    {
      title: tools,
      enabled: true,
    },
    {
      title: compliance,
      enabled: true,
    },
  ],
  learnMoreLink:
    "https://www.smartkarma.com/home/professional-investor-solutions/",
  buttonText: "Subscribe Now",
  agreement: (
    <>
      I have read and accepted the{" "}
      <a
        className="text-smart-teal"
        href={proAccessTerms}
        target="_blank"
        rel="noreferrer"
      >
        Smartkarma Pro Access Terms
      </a>
    </>
  ),
  contactSale: (
    <>
      <a
        href="https://www.smartkarma.com/home/professional-investor-solutions/#form"
        target="_blank"
        rel="noreferrer"
      >
        Contact our sales team
      </a>{" "}
      to see if you are eligible for a free 7-day trial
    </>
  ),
};

export default smartkarmaPro;
